<template>
  <div
    v-vpshow
    class="publication"
    :class="{'animation-done': animated}"
  >
    <div ref="index" class="index" :style="[{backgroundColor: data.menu_color}, {color: data.menu_text_color}]" :class="{open: indexOpen}">
      <div class="index-button" @click="toggleIndex"><a>Open menu</a></div>
      <div class="index-inner">
        <div class="logo">
          <svg :style="{fill: data.menu_text_color}" width="100" height="100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1976.69 1976.69"><g id="Layer_1" data-name="Layer 1"><path class="cls-1" d="M1387.37,1716.2c-3.85,1.87-8.93,4.48-13.72,6.59-6.87,2.87-11.36,4.87-15.25,6.24-1.05,1.16,0,3.48,1.31,3.75l5-1.68c3.61-1.25,4.72-.7,5.49,1,.7,1.59,1.42,5.95,2.14,13.43L1374,1763c.33,3.49-.34,4.31-4,5.92l-21.87,9.69c-4.35,1.93-5.12,1.75-7.55-1l-15.1-16.88c-2.7-3-4.58-5.25-5.29-6.84s1-3.22,3.92-4.85l4-2.3c.69-1.18-.48-3.43-1.9-3.49-4.13,2-9.51,4.73-16.47,7.81-6.51,2.89-11.65,5-17.72,7.33-.46.9.27,3.35,1.61,3.63l4.1-1.3c6.55-2,9.4-.7,19.12,9.9l45.65,49.44c5,5.41,10.27,11.05,15,16.59a2.23,2.23,0,0,0,2.75.34c.76-2.59,2.07-6.29,5.1-8.84-1.47-2.13-1.82-5.26-2.1-11.38l-2.56-45.66c-1.1-18.92-1.22-30.14-1.56-38-.28-6.11,2.2-9.12,5.55-11l4.58-2.55C1389.81,1718.58,1388.5,1716.39,1387.37,1716.2Zm-10,101-.29.12a104.57,104.57,0,0,1-7.37-7.65l-18.29-20.14c-3-3.34-3-4,1.2-5.91l17.82-7.89c4.06-1.8,4.27-1.72,4.58,2.13l2,29.25A92.43,92.43,0,0,1,1377.34,1817.18Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M898.29,78.05l3.5.39c6.67.77,7.55,4.08,7.84,15.17l1.56,60.19c.43,16.63.17,18.54-9,20l-3.63.57c-.92,1-.54,3.5.42,4,7.44-.51,13.14-.82,19.79-1,5.54-.14,15.72.86,25.85.6,12.2-.32,25.14-2.72,35.29-8.53,17.8-10.29,27-27.8,26.49-47.92-.54-20.91-11.78-38.69-33.37-45.9-10.39-3.53-21.66-4.19-35-3.84-13.46.35-26.28,1.16-39.73,2.3C896.78,74.76,897,77.29,898.29,78.05Zm25.55,1.24c1.24-1,6.28-2.38,15.63-2.63,41.5-1.07,50.66,28.17,51.11,45.6.77,29.46-12.49,49.94-43.22,50.73-10,.26-16-1.17-19.66-6-2.79-3.73-3.39-8.78-3.61-17.18l-1.52-58.45C922.38,84.24,922.6,80.27,923.84,79.29Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1710.14,1543.65c-9.53-8.83-22.4-8.23-31.62-6l-17.44,4.36c-13.33,3.43-20-.81-25.1-5.54-7-6.47-9-17.16.09-26.92,12.5-13.48,28.3-7.69,35.85-3.94,1.12.18,2.51-1.78,2.23-3.11-5.68-4.84-15.33-11-19.18-12-3.32,1-12,4.39-21.1,14.15-14,15.11-14.22,32.84-1.44,44.68,11,10.24,24.46,9.28,35.78,6.15l14.43-3.91c6.66-1.82,16.71-2.88,23.45,3.37,5.35,5,10.64,14.39.08,25.78-10.33,11.16-20.8,7.3-27.78,3.64-1.23-.06-2.61,2.12-2.34,3.23,4.88,4.52,12.36,9.51,16.12,11a21.31,21.31,0,0,1,4.46-3.42,61.31,61.31,0,0,0,11.53-9.41C1722.16,1570.78,1721.18,1553.88,1710.14,1543.65Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M605.78,158.76l5-1.23c6.35-1.6,7.76.74,13.18,14.78l20.48,53.08c6,15.52,6.43,17.55-1.74,21.9l-3.53,1.87c-.48,1.37.67,3.48,1.73,3.58,6.83-3,12.09-5.18,18.3-7.58,5.92-2.28,11-4.07,17.77-6.34.71-.78,0-3.41-1.13-3.81l-3.28.75c-9,2.13-10,.47-16-15l-7.19-18.63c-1.19-3.1-1-3.37,5.7-5.93,5.91-2.28,8.85-1.72,12.32.68,7.15,4.88,17.15,12.74,23.1,16.73,16.26,10.88,25.22,11.67,37.79,6.82a24.43,24.43,0,0,0,6.22-3.25,1.32,1.32,0,0,0-1-2,19.06,19.06,0,0,1-11.8-.2c-13.3-4.55-25.7-13.36-44.88-27.86-1.2-.9-2.51-2.09-2.11-3.27C681,178,689.09,166,683.67,152c-4-10.34-11.73-15-20.25-16-8.23-1.07-17.24,1.56-26.4,5.09-14.49,5.59-24.52,10-32.51,13.91C603.55,156.05,604.46,158.42,605.78,158.76Zm32.86-13c16.41-6.33,27.93,2,32.44,13.64,3.87,10.06,2.47,16.54-.32,21.19-3,4.9-8.42,7.66-13.75,9.72-7.54,2.9-9.87,3.46-10.48,3.19s-1.3-2-2.33-4.71l-13.35-34.59C629.26,150,629.47,149.28,638.64,145.74Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M758.41,207.26c4.15-1,9.67-2.5,14.79-3.56,7.33-1.36,12.14-2.37,16.23-2.89,1.27-.91.75-3.4-.49-3.95l-5.22.6c-3.79.47-4.76-.3-5.14-2.16s-.14-6.12.73-13.59l2-17.42c.41-3.48,1.24-4.14,5.12-4.95l23.43-4.87c4.65-1,5.37-.64,7.16,2.55l11.22,19.68c2,3.46,3.37,6.1,3.73,7.8s-1.66,2.94-4.85,3.93l-4.4,1.4c-.93,1-.26,3.45,1.11,3.81,4.47-1.09,10.3-2.63,17.75-4.18,7-1.45,12.44-2.42,18.87-3.44.64-.78.44-3.33-.81-3.88l-4.29.41c-6.83.61-9.33-1.3-16.6-13.7l-34.23-57.94c-3.75-6.34-7.72-13-11.16-19.37a2.22,2.22,0,0,0-2.61-.91C789.5,93,787.44,96.34,784,98.2c1,2.39.66,5.53-.35,11.56l-7.11,45.18c-2.9,18.73-5.14,29.72-6.45,37.44-1,6-4.07,8.45-7.73,9.54l-5,1.53C756.52,204.42,757.35,206.84,758.41,207.26Zm25.06-57.65,4.16-29a98.11,98.11,0,0,1,1.82-9.93l.31-.06a100.62,100.62,0,0,1,5.6,9L809,143.16c2.27,3.9,2.09,4.58-2.41,5.52l-19.08,4C783.16,153.56,783,153.43,783.47,149.61Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1284.12,1871.13l-2.69.35c-3.8.47-7.76.33-10.45-1.28-4.12-2.72-5.09-5.91-6.18-10.21l-11.2-44.4c-1.86-7.38-6.75-26.08-6-32.16.34-1.88,2.57-3.42,6-4.78l4-1.5a2.94,2.94,0,0,0-1.28-3.77c-5.3,1.67-9.41,2.87-15.86,4.5-5.69,1.43-11.1,2.63-18.09,4.07a2.9,2.9,0,0,0,.66,3.92l4.88-.74c3.91-.66,7.22-.52,8.57.94,3.77,4,9,23.89,10.79,31.11l8.45,33.49c1.17,4.61,1.9,8.18,1.75,10.18l-.3.08c-4.08-2.57-17.71-12.53-23.06-16.25l-45.88-31.56c-17.21-11.84-23-16.09-25.52-18.24-1.69.43-2.42,1.43-2.49,2.43,1.47,3.88,6.08,22.16,7.24,26.77l9.27,36.72c1.78,7.07,6.9,26,5.68,32.23-.3,1.38-3.07,3.39-7.79,5.4l-2.07.85a2.78,2.78,0,0,0,1.27,3.76c5.15-1.62,9.11-2.79,15.71-4.45,5.84-1.48,11.1-2.64,18.25-4.12,1.11-.77.65-3.26-.66-3.92l-2.69.36c-6.34.78-9,.48-10.3-.67-4.09-3.88-9.28-23.81-11.1-31l-8.3-32.88c-.81-3.23-1.43-5.68-1-6.61l.3-.08c9.09,5.56,18.79,12.26,32.37,21.42l19.13,13c6.51,4.41,29.75,20.11,34.8,27.17a51.87,51.87,0,0,1,7-2.24c2.76-.7,10.91-2.75,17.47-3.92C1285.86,1874.12,1285.28,1871.82,1284.12,1871.13Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1912.59,966c-2.54.5-5.55-.43-11.28-2.6l-42.91-15.82c-17.8-6.51-28.14-10.86-35.45-13.66-5.72-2.17-7.49-5.64-7.84-9.44l-.52-5.23c-.8-.94-3.33-.6-3.95.35.19,4.28.55,10,.59,15.21-.09,7.45,0,12.36-.34,16.48.65,1.42,3.18,1.4,4,.29l.43-5.24c.29-3.8,1.23-4.6,3.13-4.62,1.74,0,6,1.06,13.18,3.38l16.68,5.41c3.34,1.09,3.82,2,3.85,6l.2,23.92c0,4.76-.43,5.39-3.91,6.53l-21.49,7.15c-3.8,1.29-6.64,2.11-8.39,2.12-1.58,0-2.55-2.19-2.89-5.52l-.52-4.59c-.8-1.1-3.33-.92-4,.35.19,4.59.56,10.61.62,18.22.06,7.13-.06,12.67-.32,19.17.64.79,3.18,1.09,4,0l.44-4.28c.74-6.82,3.1-8.9,16.69-13.6l63.52-22.23c7-2.43,14.22-5,21.18-7.14a2.25,2.25,0,0,0,1.4-2.39C1916.6,972.47,1913.73,969.8,1912.59,966Zm-23.24,7-25.76,8.77c-4.27,1.46-4.9,1.15-4.94-3.45l-.16-19.49c0-4.44.12-4.6,3.78-3.36l27.65,9.76a97.75,97.75,0,0,1,9.38,3.73v.32C1897.41,970.25,1893.14,971.71,1889.35,973Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1480.37,331.8c4.31,3.51,7.57,6.28,12.48,10.77,4.33,4,8.31,7.82,13.36,12.86a2.91,2.91,0,0,0,2.91-2.71l-3.31-3.66c-2.7-2.91-4.4-5.75-3.93-7.68,1.23-5.32,15-20.63,20-26.12l23.32-25.49c3.21-3.51,5.78-6.09,7.54-7.06l.23.21c.1,4.82-.72,21.68-.88,28.19L1551,366.79c-.42,20.88-.78,28.07-1.19,31.35,1.29,1.17,2.52,1.23,3.4.74,2.43-3.36,15.16-17.27,18.37-20.78l25.56-27.94c4.92-5.38,17.95-20.09,23.79-22.48,1.32-.51,4.51.7,8.79,3.53l1.85,1.27a2.79,2.79,0,0,0,2.44-3.14c-4.19-3.4-7.33-6.07-12.36-10.66-4.44-4.07-8.31-7.82-13.48-13-1.25-.5-3.08,1.26-2.9,2.71l1.77,2c4.14,4.87,5.37,7.28,5.11,9-1,5.54-14.78,20.85-19.8,26.34l-22.89,25c-2.25,2.46-4,4.33-5,4.48l-.24-.21c-.36-10.64-.1-22.43.07-38.81l.32-23.12c.1-7.85.42-35.91,3.54-44a52,52,0,0,1-5.7-4.57c-2.1-1.92-8.3-7.59-12.89-12.44-1.36-.38-3,1.37-2.91,2.71l1.78,2.05c2.48,2.92,4.54,6.31,4.68,9.44,0,4.94-2.14,7.5-5.13,10.77l-30.91,33.79c-5.14,5.61-18.07,20-23.56,22.69-1.76.76-4.27-.25-7.28-2.36l-3.48-2.54A2.94,2.94,0,0,0,1480.37,331.8Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1777.07,754.12a32,32,0,0,1,3.28,4.75c3.61,1.29,14.84,1.85,23,.26.85-1,.39-3.31-.72-4.11-10-.46-25.52-4.76-32.06-24.12-8.32-24.62,2.35-50.47,33.88-61.12,31.08-10.49,52.23,4.1,60,27.07,7.35,21.77-2.08,32.48-11.53,38.18-.54,1.36.37,3.56,1.67,4,8.75-4.29,18-8.24,21.36-9.55a11.91,11.91,0,0,1-.82-4.41,122.17,122.17,0,0,0-5.37-27.79c-5.27-15.61-14.19-28.15-26.45-36.22-12.71-8.42-29.51-11.11-46.17-5.48-19.37,6.54-29.89,20.46-34.09,35.26-3.65,13.44-2,27.27,2.57,40.78C1768.85,741.18,1774.76,751.23,1777.07,754.12Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1874.09,809.51l-56.29,9.27c-16.42,2.7-18.66,2.75-21.09-6.16l-1.24-4.62c-1.09-.78-3.54-.06-3.86,1,1.76,8.7,2.74,13.68,3.82,20.25l2.37,14.38c2.65,16.11,4.94,31,5.94,39,4.58,1.5,21.25,3.25,23,3,1.1-.18,1.23-3.25.3-4.06-8.49-1.81-14.79-5-17.18-7.77-1.82-2.27-3-5.45-5.18-18.74-2-12.35-.64-15.63.79-17.63,2.51-3.31,6.5-4.45,16.35-6.07l54.41-9c16.42-2.7,19-2.8,21.27,6.29l.93,3.7c.78.84,3.54.06,3.86-1-1.6-7.77-2.63-13.06-3.64-19.16-1-6.25-1.75-11.59-2.88-20.4-.62-.86-3.49-.71-4,.33l.33,4C1893,806.08,1890.5,806.81,1874.09,809.51Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1159.8,104.23c2.69-3.4,5.11-6.37,9.67-8.78,4.75-2.52,13.26-.62,19.85,1.1l8.44,2.21c4.6,1.2,4.55,1.36,3.31,6.11l-17.93,68.52c-4.21,16.1-5.58,18.2-14.51,16.68l-5.64-1c-1.43.45-1.8,3.14-1,3.84,9.9,2.26,15.3,3.51,21.43,5.11s11.31,3.12,20,5.72c1.05-.22,2.07-2.9,1.31-3.76l-4.78-1.74c-8.69-3.09-8.4-5.47-4.18-21.57l17.84-68.22c1.33-5.06,1.21-5.25,5.81-4l10.89,2.85c8.43,2.21,13.93,5,16.78,8.49,1.85,2.28,1.44,8.24.9,12.19.53,1.12,3.13,1.8,4.07.74.74-4.72,5.06-16.86,8.39-22.7-.14-.7-1.79-1.29-2.64-1.19-3.34,3.39-4.8,3.33-13.08,1.17L1182.6,89.71c-7-1.84-12.15-3-11.79-8.16-.34-.58-2.37-.94-2.91-.76a168.46,168.46,0,0,1-11.8,21.32A3.06,3.06,0,0,0,1159.8,104.23Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M487,242.79c-.49-4.3-.87-8.11.65-13,1.59-5.14,9-9.8,14.84-13.24l7.53-4.39c4.11-2.39,4.19-2.26,6.66,2l35.69,61.18c8.39,14.37,8.9,16.82,1.5,22.06l-4.69,3.28c-.7,1.33.93,3.49,2,3.43,8.6-5.39,13.32-8.32,18.79-11.51s10.21-5.77,18.17-10.05c.58-.89-.58-3.51-1.72-3.58l-4.62,2.14c-8.34,3.95-9.81,2.05-18.19-12.32l-35.53-60.91c-2.64-4.51-2.85-4.57,1.25-7l9.72-5.66c7.53-4.4,13.37-6.34,17.87-5.84,2.93.3,6.85,4.81,9.25,8,1.17.42,3.49-.93,3.4-2.35-2.8-3.87-8.31-15.51-10.08-22-.59-.39-2.18.35-2.7,1,0,4.75-1.05,5.74-8.44,10.06l-55.44,32.33c-6.29,3.67-10.73,6.45-14.11,2.54-.65-.17-2.35,1-2.6,1.52a167.36,167.36,0,0,1,6.7,23.43C484.11,244.69,486.43,244.25,487,242.79Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1399.42,286.75c26.34,15.54,59.19,7.88,75.46-19.69,14.17-24,11.78-56.15-19.74-74.75-28.12-16.59-60.91-7.79-77,19.51C1363.64,236.39,1369.12,268.88,1399.42,286.75Zm-5.07-71.24c17.64-29.89,41.78-28.71,56-20.34,26.07,15.38,21.7,45.55,8.41,68.07-15.86,26.88-38.66,30-55,20.33C1376.8,267.7,1382.44,235.7,1394.35,215.51Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1288.79,230.89c5.86,2.41,10.79,4.61,18,7.91,1.06-.07,2.44-2.59,1.8-3.54l-3.48-1.95c-8.23-4.58-7.67-6.75-1.28-22.28l21.46-52.17c6.39-15.54,7.7-17.91,16.65-15.08l3.79,1.21c1.12-.22,1.91-3,1.21-3.78-7.45-2.72-12.49-4.63-18.35-7-6.16-2.53-11.08-4.73-18.29-8-1.06.07-2.43,2.59-1.8,3.54l3.55,1.8c8.34,4.29,7.61,6.9,1.22,22.43l-21.46,52.17c-6.39,15.54-7.53,17.47-16.6,14.94l-3.84-1.07c-1.24.52-1.91,3-1.21,3.78C1277.59,226.45,1282.64,228.36,1288.79,230.89Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1072.67,179.51c6.3.74,11.63,1.53,19.46,2.77,1-.36,1.65-3.16.78-3.9l-3.88-.93c-9.16-2.2-9.21-4.44-7.25-21.12l6.61-56c2-16.68,2.6-19.32,12-19l4,.15c1-.51,1-3.38.15-4-7.9-.61-13.27-1.08-19.57-1.83-6.61-.78-11.94-1.56-19.77-2.81-1,.37-1.65,3.16-.78,3.9l3.9.78c9.19,1.88,9.19,4.59,7.23,21.28l-6.61,56c-2,16.68-2.54,18.85-12,18.85h-4c-1,.83-1,3.39-.14,4C1060.69,178.26,1066.06,178.73,1072.67,179.51Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M569.1,1698.39c-7.89-5-12.42-8-18-11.82l-11.76-8.07c-11.62-8-23.15-16.11-34.73-24.44a138.67,138.67,0,0,0-18.35,14.11,2.92,2.92,0,0,0,2.64,3.16c8.06-4.46,14.73-6.61,18-6.3,3.86.54,8,2.62,18.06,9.53,11.49,7.9,13.25,11.22,13.74,13.86.56,3.66-2.1,8.37-6.85,15.29l-12.66,18.41c-2.33,3.4-2.81,3.26-6.73.57l-7.57-5.21c-5.1-3.5-8.14-5.78-9.61-7.56-2.16-2.45-1.73-5-.64-7.74l2.32-5.9c-.11-1.24-2.33-2.76-3.48-2.21-2,2.88-4.86,8.2-8.09,12.9-3.41,5-7.44,9.7-9.59,12.83-.11,1.27,2.12,2.8,3.31,2.46l4.72-4.63c2.9-2.82,4.35-3,6.28-2.42s6.15,3.08,11.64,6.84l7.57,5.21c3.92,2.69,4.31,3,1.8,6.62L493.12,1760c-3.41,5-3.59,5.22-7.51,2.53l-9.4-6.46c-5.75-4-9.84-7-12.13-9.49-5.63-6.36-3.66-11.74-1.4-19.23-.12-1.23-2.39-2.4-3.45-2-3.42,6.11-9.1,16.05-9.84,18.81,1.84.68,9.54,6,17.9,11.72l24.55,16.87c5.36,3.68,9.71,6.86,15.14,11,1.06.15,2.93-2,2.51-3.08l-1.91-1.7c-7.08-6.21-6-8.35,3.34-21.93l32.3-47c9.43-13.71,11.42-15.22,19.32-10.76l4.58,2.57C568.44,1701.59,569.61,1699.32,569.1,1698.39Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M439.46,1602.84c-12.84,5.41-34.27,12-46.67,15.48,4.93-11.08,13.47-31.18,20.53-44.4a5.11,5.11,0,0,0-1.14-2,3.35,3.35,0,0,0-1.62-1.09c-16.94,6.55-32.71,12.25-49.38,17.92l-27.62,9.37c-22.72,7.72-27.2,9.85-33.1,4.5l-2.25-2c-1.69,0-3.11,1.52-2.61,2.78,3,2.85,6.19,6.15,10.23,10.62,3.3,3.64,6.05,6.92,9.85,11.6,1.32.52,2.72-.53,2.93-2.43l-2.85-3.62c-2.11-2.58-2.45-4.84-.8-6.32,1.41-1.28,8.27-3.85,13.88-6.15,2.86-1.09,24.13-9,31.9-11.73,11.43-4.14,22.84-8.05,34.37-11.84-5.43,12-10.53,24-16,36.21a12.07,12.07,0,0,1-2.08,3.38,13.23,13.23,0,0,1-3.78,1.49c-5.71,1.95-20.4,6.26-27,7.72-7.15,1.77-14.36,4.44-19.17-.18l-3.32-3.2c-1.58.15-3,1.64-2.61,2.79,2.68,2.49,7.05,7.08,10.56,11,3.93,4.35,7,8,9.63,11.37,1.1.51,2.6-.43,3-2.31l-2.95-3.74c-3.16-4-2.4-5.73,11.42-10.53,8.68-3.15,15.06-5.07,21.67-7-4.32,9.88-8.75,19.86-12.28,27.54-3.27,7-4.2,7.64-8.7,3.37l-3-2.84c-1.58.14-3,1.64-2.61,2.78,2.68,2.49,6.72,6.74,12,12.61,4.25,4.71,8.17,9.28,11,12.9,1.32.52,2.84-.64,3-2.31l-2.32-3c-3.26-4.31-2.38-8.31-.33-13.36,5.37-13,10.84-25.82,16.53-38.43a13.65,13.65,0,0,1,2.2-3.71c.59-.53,3.33-1.51,6.52-2.47,9.35-2.9,18.8-5.67,27.23-8.16-8.3,19.88-16.73,40.1-25.47,60-5.05,11.18-8.82,19.07-10.23,20.35-1.06,1-3,.18-5.5-2.08l-2.68-2.49c-1.46,0-3.22,1.41-2.61,2.79,3.95,3.9,9.49,9.79,12.46,13.08,3.3,3.64,8,9,10.59,12.43,1.32.51,3.08-.86,3.14-2.2l-2.31-3c-4-5.37-2.09-9.65.71-16.24,9.43-22.41,19.19-44.46,28.73-66.75,2-4.61,8.46-18.76,11.59-25.22a6.19,6.19,0,0,0-1.24-2.08A3.38,3.38,0,0,0,439.46,1602.84Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M144.31,1205.52c20.15-3.44,32.7-15.55,39.16-29.51,5.71-12.71,6.22-26.63,3.82-40.69-1.71-10-6-20.84-7.81-24.06a32.34,32.34,0,0,1-2.49-5.2c-3.37-1.84-14.37-4.14-22.68-3.84-1,.81-.9,3.21.07,4.17,9.83,2,24.47,8.68,27.91,28.83,4.38,25.61-10.19,49.48-43,55.08-32.33,5.53-50.95-12.19-55-36.09-3.87-22.65,7.11-31.76,17.33-35.91.75-1.26.2-3.57-1-4.17-9.31,2.88-19,5.34-22.59,6.11a12,12,0,0,1,.13,4.48,122.14,122.14,0,0,0,1,28.29c2.78,16.24,9.63,30,20.48,39.9C110.8,1203.21,127,1208.49,144.31,1205.52Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M211.16,1242.23c-.74-.76-3.56-.2-3.87.9l.74,3.92c1.77,9.25-.24,10.22-16.25,15.3L138,1279.43c-16,5.09-18.67,5.6-22.25-3.07l-1.51-3.68c-.89-.72-3.51.45-3.67,1.5,2.7,7.45,4.48,12.54,6.4,18.58,2,6.35,3.49,11.53,5.59,19.18.74.76,3.55.2,3.87-.9l-.9-3.87c-2.07-9.15.4-10.27,16.41-15.36l53.76-17.07c16-5.09,18.22-5.45,22.11,3.12l1.65,3.63c1.19.62,3.51-.45,3.68-1.5-2.7-7.46-4.48-12.54-6.5-18.89C214.73,1255.06,213.25,1249.88,211.16,1242.23Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1773.05,1387.23c-17.54-10.5-35-9.47-49-3.07-12.6,5.94-22,16.17-29.37,28.4-5.21,8.71-9,19.72-9.73,23.36a31.23,31.23,0,0,1-1.49,5.57c1.37,3.59,8.23,12.49,14.73,17.68,1.27,0,2.77-1.85,2.66-3.21-6.16-7.93-12.94-22.52-2.44-40.06,13.34-22.3,39.94-30.94,68.49-13.85,28.15,16.84,30.76,42.41,18.31,63.21-11.8,19.72-26.07,19.49-36.53,16-1.39.46-2.47,2.58-1.93,3.83,9,3.88,17.92,8.32,21.13,10.06a11.91,11.91,0,0,1,2.82-3.48,123,123,0,0,0,17.67-22.12c8.46-14.14,12.22-29.06,10.41-43.63C1797,1410.79,1788.14,1396.26,1773.05,1387.23Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1855.24,1318.22l-1.83,3.53c-4.34,8.32-6.94,7.57-22.44,1.08l-52-21.78c-15.5-6.48-17.42-7.63-14.84-16.68l1.1-3.84c-.51-1.25-3-1.93-3.78-1.24-2.77,7.43-4.7,12.46-7.27,18.6-2.45,5.85-4.68,10.76-8,17.94.07,1.06,2.58,2.46,3.53,1.82l2-3.46c4.64-8.2,6.8-7.64,22.3-1.15l52,21.78c15.49,6.49,17.85,7.82,15,16.75l-1.23,3.77c.21,1.13,3,1.94,3.77,1.24,2.77-7.43,4.7-12.46,7.15-18.31,2.57-6.14,4.8-11,8.15-18.23C1858.7,1319,1856.19,1317.59,1855.24,1318.22Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M694.4,1761c-5.3-2.5-10.25-5-16.57-8.32a2.89,2.89,0,0,0-2,3.45l4.24,2.52c3.45,2,5.91,4.18,6,6.16.41,5.45-8.21,24.16-11.38,30.9L660.05,1827c-2,4.31-3.72,7.54-5.1,9l-.29-.14c-1.53-4.57-5.75-20.91-7.53-27.18l-15.46-53.5c-5.8-20.06-7.6-27-8.17-30.28-1.58-.75-2.77-.43-3.47.29-1.32,3.93-9.35,21-11.37,25.3l-16.12,34.27c-3.1,6.59-11.18,24.51-16,28.52-1.12.88-4.52.68-9.45-.76l-2.14-.66a2.78,2.78,0,0,0-1.4,3.72c5,2,8.81,3.62,15,6.52,5.45,2.56,10.26,5,16.72,8.39,1.35.1,2.57-2.12,2-3.45l-2.3-1.44c-5.4-3.41-7.29-5.35-7.54-7-.7-5.58,7.92-24.29,11.09-31l14.43-30.68c1.42-3,2.5-5.31,3.41-5.76l.29.14c3.5,10,6.75,21.39,11.45,37.08l6.56,22.17c2.23,7.53,10.25,34.42,9.68,43.08a51.3,51.3,0,0,1,6.8,2.67c2.58,1.22,10.18,4.79,16,8.06,1.41,0,2.43-2.19,2-3.46l-2.3-1.43c-3.24-2.05-6.21-4.67-7.27-7.62-1.46-4.72-.19-7.79,1.7-11.81l19.49-41.44c3.24-6.88,11.32-24.44,15.76-28.66,1.46-1.24,4.15-1,7.65.1l4.08,1.39a3,3,0,0,0,1.4-3.72C704.36,1765.55,700.43,1763.87,694.4,1761Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1113.85,1912.32l-3.5-.41c-6.67-.81-7.53-4.13-7.75-15.21l-1.2-60.21c-.34-16.63-.06-18.54,9.11-20l3.63-.55c.93-1,.56-3.5-.4-4-7.44.46-13.14.73-19.79.87-5.55.11-15.71-1-25.85-.75-12.2.24-25.15,2.56-35.34,8.31-17.86,10.19-27.18,27.65-26.78,47.77.42,20.91,11.56,38.75,33.1,46.09,10.37,3.6,21.64,4.32,35,4.06,13.47-.27,26.29-1,39.74-2.07C1115.34,1915.62,1115.13,1913.09,1113.85,1912.32Zm-25.55-1.39c-1.24,1-6.29,2.34-15.64,2.53-41.5.83-50.49-28.47-50.84-45.9-.59-29.46,12.79-49.86,43.53-50.47,10-.2,16,1.26,19.61,6.1,2.77,3.75,3.35,8.81,3.52,17.21l1.17,58.46C1089.79,1906,1089.55,1910,1088.3,1910.93Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M397.85,344.59c-5.42,15.49-8.08,30.33,2.49,43,8,9.59,25,16.27,42.13,1.93,10.81-9.05,13.76-23.3,14.18-36.88,3.27,1.19,13.62,4.92,16.77,5,4,.13,10.48-2.79,15.95-7.36,7.53-6.31,12.73-14.17,12.5-24.32a2.14,2.14,0,0,0-3.17-1.07c-.35,5.26-3.5,10.38-7.27,13.53-5,4.17-12.09,8.27-26.77,3.82-2.74-.81-4.29-1.17-9.1-2.72-.8-11.32-1.51-22.29-2.89-32.09-1.32-9.23-2.88-18.25,2.88-24.94l4.64-5.33a2.9,2.9,0,0,0-2.69-2.71c-3.07,3-7.61,7.2-16.72,14.83l-10,8.34a2.59,2.59,0,0,0,2.19,3.12l4.54-3c2.15-1.38,4-1.67,4.69-.82s1.52,3.06,2.92,8.92a228.7,228.7,0,0,1,5.16,31.84c-18.11-5.09-33-5.84-43.14-4.38,3.1-8.39,6.78-16.84.06-24.85-7-8.39-18.54-9.07-27.77-1.34-8.75,7.32-11.32,21-3.28,30.64C382,344.65,390.94,345.22,397.85,344.59Zm53.56,6.21c-.08,11-3.4,21.86-11.54,28.67-10.69,8.95-24.41,7.63-33.47-3.19-8.23-9.84-6.79-23.66-3.25-31.78C418.26,342.8,437,345.48,451.41,350.8ZM381.93,311c5.83-4.88,12.88-1.9,17.36,3.45,4.88,5.83,5.07,12.49,3.28,18.74-9.71,1.73-16.77.2-21.05-4.9S376.58,315.48,381.93,311Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M138.29,710.82c12.19,4.5,23.85-1,31.5-6.62l14.43-10.72c11-8.28,18.76-6.93,25.31-4.52,8.92,3.3,14.84,12.41,10.24,24.89-6.37,17.25-23.18,18-31.59,17.4-1.11.27-1.63,2.61-.87,3.74,7.1,2.28,18.37,4.24,22.3,3.66,2.67-2.22,9.45-8.68,14-21.16,7.13-19.33.53-35.78-15.82-41.81-14.12-5.21-26.14.82-35.4,8.05l-11.82,9.15c-5.45,4.24-14.32,9.07-23,5.89-6.84-2.52-15.35-9.21-10-23.78,5.26-14.27,16.41-14.72,24.26-14,1.16-.41,1.59-3,.92-3.88-6.24-2.3-15.06-4-19.12-4a21.45,21.45,0,0,1-2.82,4.87,61.44,61.44,0,0,0-7,13.11C116.78,690.39,124.17,705.61,138.29,710.82Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1888.78,1078.91c-12.86-1.84-23.1,6-29.39,13.1l-11.85,13.52c-9,10.4-16.89,10.72-23.79,9.74-9.41-1.34-17.13-9-15.25-22.18,2.59-18.2,18.88-22.44,27.21-23.66,1-.49,1-2.89.07-3.83-7.42-.73-18.85-.28-22.57,1.11-2.15,2.74-7.41,10.47-9.29,23.65-2.9,20.39,7,35.09,24.27,37.54,14.91,2.13,25.39-6.31,32.91-15.32l9.63-11.43c4.44-5.3,12.1-11.89,21.2-10.59,7.21,1,16.94,5.77,14.75,21.14-2.14,15.06-12.94,17.85-20.76,18.82-1.05.65-.94,3.22-.09,4,6.59.93,15.58.77,19.55-.11a20.86,20.86,0,0,1,1.72-5.35,61.24,61.24,0,0,0,4.11-14.3C1914.11,1094.35,1903.69,1081,1888.78,1078.91Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M1869.22,1199.36c-12.51-3.51-23.7,2.89-30.87,9.1l-13.54,11.83c-10.3,9.12-18.16,8.39-24.87,6.51-9.15-2.58-15.78-11.19-12.18-24,5-17.7,21.68-19.75,30.11-19.85,1.08-.35,1.42-2.73.57-3.79-7.26-1.71-18.65-2.77-22.52-1.88-2.49,2.42-8.73,9.39-12.33,22.2-5.58,19.84,2.3,35.71,19.08,40.43,14.5,4.08,26-2.89,34.65-10.83l11.06-10.06c5.1-4.66,13.56-10.18,22.41-7.69,7,2,16,8,11.83,22.91-4.12,14.65-15.19,16-23.07,15.9-1.13.51-1.36,3.08-.62,3.94,6.41,1.81,15.34,2.83,19.39,2.49a21,21,0,0,1,2.41-5.08,60.56,60.56,0,0,0,6-13.63C1892.28,1218,1883.71,1203.44,1869.22,1199.36Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M75.72,879.26l.87-2.57c1.24-3.62,3.11-7.11,5.74-8.83,4.25-2.5,7.54-2,11.88-1.06L139,876.23c7.44,1.57,26.39,5.4,31.51,8.75,1.55,1.13,2,3.81,1.67,7.47l-.42,4.29a2.94,2.94,0,0,0,3.94.5c.84-5.49,1.56-9.71,2.93-16.22,1.21-5.74,2.51-11.13,4.29-18a2.91,2.91,0,0,0-3.81-1.12l-1.48,4.71c-1.13,3.81-2.71,6.71-4.61,7.28-5.21,1.66-25.4-2.43-32.69-4l-33.8-7.12c-4.65-1-8.18-1.88-9.91-2.9l.06-.31c4.1-2.53,19-10.4,24.72-13.58l48.51-27.35c18.19-10.26,24.57-13.61,27.59-14.92.36-1.7-.22-2.8-1.08-3.3-4.13-.39-22.58-4.27-27.24-5.25l-37.05-7.8c-7.14-1.51-26.43-5.24-31.46-9.06-1.11-.88-1.69-4.24-1.43-9.37l.15-2.23a2.78,2.78,0,0,0-3.94-.51c-.8,5.34-1.49,9.4-2.9,16.07-1.24,5.89-2.5,11.13-4.31,18.2.2,1.34,2.65,2,3.81,1.13l.86-2.57c2.08-6,3.54-8.33,5.13-9,5.27-2,25.46,2.12,32.75,3.65l33.18,7c3.26.68,5.74,1.21,6.38,2l-.06.31c-9,5.72-19.26,11.49-33.46,19.68L116.8,834.15c-6.82,3.91-31.14,17.9-39.7,19.33a49.53,49.53,0,0,1-1,7.23c-.58,2.79-2.31,11-4.15,17.43C72.27,879.51,74.6,880,75.72,879.26Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M120.5,1053.07c28.52.45,54-20.38,54.6-55.55.48-30.58-22.43-55.35-54.43-55.85-27.89-.44-54.64,17.52-55.21,54.12C64.94,1028.43,88.81,1052.57,120.5,1053.07Zm4.83-95.48c31.21.49,45.19,18.78,44.89,37.79-.5,31.21-31.09,42.14-54.54,41.77C81,1036.6,70.07,1015,70.33,998.56,70.8,968.3,99.19,957.17,125.33,957.59Z" transform="translate(-3.85 -6.9)"/></g><g id="Layer_2" data-name="Layer 2"><path class="cls-1" d="M1908.17,623.34c-49.72-122.6-122.77-232.61-217.11-327S1486.71,129,1364.1,79.28A984.85,984.85,0,0,0,992.19,6.9h0a985,985,0,0,0-371.9,72.37C497.68,129,387.68,202,293.33,296.38s-167.39,204.35-217.1,327a991.77,991.77,0,0,0,0,743.83c49.72,122.6,122.77,232.61,217.11,326.95s204.35,167.39,327,217.11a991.81,991.81,0,0,0,743.82,0c122.61-49.72,232.61-122.77,327-217.11s167.4-204.35,217.11-326.95a991.81,991.81,0,0,0,0-743.82ZM1898,1363c-49.16,121.23-121.39,230-214.69,323.3S1481.2,1851.83,1360,1901a980.82,980.82,0,0,1-735.54,0c-121.23-49.16-230-121.39-323.29-214.68S135.61,1484.24,86.45,1363a980.8,980.8,0,0,1,0-735.53c49.16-121.23,121.39-230,214.69-323.3S503.2,138.66,624.43,89.5a980.8,980.8,0,0,1,735.53,0c121.23,49.16,230,121.4,323.29,214.69s165.53,202.07,214.69,323.3a980.71,980.71,0,0,1,0,735.52Z" transform="translate(-3.85 -6.9)"/></g><g id="Layer_3" data-name="Layer 3"><path class="cls-1" d="M1761.34,995.25A766.79,766.79,0,1,0,1705,1284.68,766.36,766.36,0,0,0,1761.34,995.25Zm-291-581v146c0,82.2,3.9,117,15.47,137.79,13.39,24.1,38,26.72,69.19,30l49.11,5.45c3.23,4.44,4.69,12.38,3.49,19.77-.8,4.92-2.68,8.87-5.05,10.71-86.06-3-148.3-4.21-207.86-4.21-59.39,0-123,1.22-219.23,4.22-2.73-2.23-4.88-7.82-5.39-14.25-.6-7.63,1.2-13.67,3.4-16.21l58.15-6.92.28,0c33.69-4.3,55.94-7.14,68.84-29.85,13-22.88,15.44-65.62,15.44-136.5V309.65q30.49,14.4,59.46,31.39l47.15,30.09q23.84,16.49,46.45,34.86A33.73,33.73,0,0,1,1470.38,414.2ZM366,1422.88q-1.2-14.34-1.2-29.13c0-67.72,24.34-135,70.4-194.72,36.51-47.29,86.63-89.23,137.9-115.47,72.13,48.17,146.83,113.64,216.19,189.51C856.78,1346.9,916.1,1427,961,1505c-44,51.21-92.2,91.8-143.37,120.7q-80.2,45.28-163.2,48.56a754.82,754.82,0,0,1-198.33-142.91A762.63,762.63,0,0,1,366,1422.88Zm447.06,309.17q3.93-2.33,7.83-4.72c60-36.81,118.93-87.73,180-155.53,39,67.11,88.86,148.32,112.91,169.16.85.76,1.72,1.51,2.62,2.26a765.22,765.22,0,0,1-303.39-11.17Zm464.42-34.21a755.13,755.13,0,0,1-146,42.74c-3.43-2.44-8-5.77-10.34-7.9-18.53-16.06-59.18-77.5-114.47-173l-3.82-6.6-5.07,5.7c-62.19,69.82-121.93,121.88-182.64,159.14q-8.65,5.31-17.37,10.23a757.07,757.07,0,0,1-90.83-30.32q-16.33-6.61-32.26-14c50.19-5,100-21.25,148.43-48.61,53.29-30.08,103.38-72.51,148.88-126.1l2.5-3-1.92-3.36c-45.55-79.71-106.1-161.74-175.11-237.22-70.83-77.46-147.22-144.22-220.91-193l-2.66-1.77-2.86,1.43c-53.7,26.85-106.38,70.6-144.54,120-47.57,61.62-72.71,131.28-72.71,201.46,0,3.67.06,7.31.17,10.94a752.26,752.26,0,0,1-64.32-124.16q-5.25-12.94-10-26a419.41,419.41,0,0,1,32-43.2c47.8-56.75,114.23-108.93,215.41-169.18l7.36-4.38-7-4.89c-41.93-29.12-73.75-58.78-97.28-90.68C399.32,900.5,383.74,855.36,383.74,808c0-68.89,28.31-132.83,79.73-180,48.68-44.7,114.34-70.34,180.14-70.34,34.66,0,67.32,5.55,97.07,16.51,28.8,10.61,54.19,26,75.46,45.75,42.87,39.81,66.48,95.85,66.48,157.8,0,52.47-17.13,94.27-53.9,131.55C796,942.43,751.3,967.79,708.08,992.32l-14.14,8-8.05,4.61,7.89,4.88c69.52,43,208.79,148.19,360.4,369.95l4.37,6.4,4.62-6.22c42.29-57,142.7-218.74,197.64-332.55,28.46-56.91,42.29-91.82,42.29-106.72,0-16.75-20.74-29.74-54.16-33.92l-62.4-7.34c-4-4.86-5.93-12.34-5.1-19.63.44-3.86,2.06-10.74,7.9-15.11h153.73c144.14,0,217.7-3.94,265.51-7.43,3.41,3.14,5.68,8.09,6.46,14.15,1,7.47-.63,15.45-4,20.58l-81.21,12.92c-46.33,7.58-87.32,31-125.34,71.64-33.63,35.95-61,80.11-89.86,126.87q-3.3,5.31-6.59,10.64c-58,93.1-128.21,190-202.58,292.65l-17.09,23.59-2.19,3,2,3.16c23.15,36.76,35.64,55.11,47.73,72.85,4.69,6.89,9.55,14,14.87,22,46,70.33,94.47,117.69,148.09,144.78q6.91,3.48,13.72,6.41Q1295.28,1690.62,1277.47,1697.84Zm250.79-166.54A754.49,754.49,0,0,1,1326,1676.12a241.46,241.46,0,0,1-22.18-9.83c-51.85-26.19-98.9-72.3-143.86-141-5.38-8.08-10.25-15.23-15-22.14-11.68-17.15-23.75-34.86-45.53-69.37l14.9-20.56c74.49-102.79,144.85-199.87,203-293.31q3.32-5.33,6.6-10.66c56.43-91.23,109.73-177.4,207.57-193.41l85.45-13.6,1.33-1.59c6.17-7.4,9.08-19.13,7.6-30.62-1.28-10-5.69-18.09-12.42-22.9l-1.63-1.16-2,.15c-47.57,3.52-120.89,7.57-266.87,7.57h-157l-1.34.84c-7.86,4.91-13,13.68-14.23,24.05-1.3,11.38,2.33,22.89,9.46,30l1.36,1.36,66.31,7.8c30.54,3.81,44.45,14.57,44.45,23,0,8.91-7.13,33.81-41.15,101.85-51,105.61-147.2,262.35-192,324.59C913.3,1156,779.24,1051.21,707.42,1005.39l6.11-3.47c88.55-50.27,180.12-102.24,180.12-224.23,0-65.05-24.86-124-70-165.88-22.35-20.76-49-36.91-79.15-48-31-11.41-64.93-17.2-100.89-17.2-68.54,0-136.91,26.7-187.61,73.25C402.29,669.17,372.71,736,372.71,808c0,49.76,16.3,97.1,48.46,140.71,22.93,31.08,53.37,60,92.9,88.28-98.19,59.08-163.45,110.84-210.91,167.19A437.81,437.81,0,0,0,275,1241.42,758.55,758.55,0,0,1,1277.47,292.65q14,5.69,27.72,11.9V560.21c0,67.37-2.29,110.41-14,131-10.17,17.92-28.1,20.2-60.64,24.36l-61.45,7.32-1.15.82c-7.63,5.45-9.57,17.43-8.83,26.83.9,11.52,5.54,20.45,12.42,23.89l1.24.62,1.4,0c97-3,161-4.27,220.56-4.27,59.8,0,122.35,1.28,209.14,4.27l1.4.05,1.26-.63c6.12-3.06,10.49-10.15,12-19.45,2.37-14.58-2.68-25.64-7.72-30.68l-1.37-1.37-53.21-5.92c-32.94-3.5-50.6-6.18-60.74-24.42-11.77-21.2-14.08-64.61-14.08-132.43V416.06q24.18,20.49,46.85,43.13a757.46,757.46,0,0,1,0,1072.11Z" transform="translate(-3.85 -6.9)"/><path class="cls-1" d="M543.27,870.32c-25.36-33.43-38.21-69.7-38.21-107.8,0-37.77,13-75.45,35.73-103.38,24.39-30,58.22-46.54,95.23-46.54v-11c-40.4,0-77.26,18-103.8,50.61C508,682,494,722.26,494,762.52c0,40.57,13.61,79.08,40.46,114.46,26.16,34.49,65.78,67.11,117.75,96.94l5.5-9.57C607,935.26,568.54,903.62,543.27,870.32Z" transform="translate(-3.85 -6.9)"/></g></svg>
        </div>
        <div class="title">{{ title }}</div>
        <div class="description">{{ data.sub_heading }}</div>
        <div class="menu-wrapper">
          <div class="menu-preloader">
            <svg 
              :style="{stroke: data.menu_text_color}"
              width="38"
              height="38"
              viewBox="0 0 38 38"
              xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fill-rule="evenodd">
                <g transform="translate(1 1)" stroke-width="2">
                  <circle stroke-opacity=".1" cx="18" cy="18" r="18"/>
                  <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="1s"
                        repeatCount="indefinite"/>
                  </path>
                </g>
              </g>
            </svg>
            <div>Loading publication</div>
          </div>
          <ul>
            <li
              v-for="(article, index) in chapters"
              :key="'index-' + index"
              :class="[{highlight: highlight === index}, {dim: highlight !== index && highlight !== null && activeArticle !== index}]"
              @mouseenter="highlightArticle(index)"
              @mouseleave="clearHighlight()"
              @click="setActiveArticle(index)"
            >
              <sup>{{ ('0' + (index + 1)).slice(-2) }}</sup> <span v-if="article.description" class="index-description">{{ article.description }}: </span><span class="index-title">{{ article.title }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="data.related" class="related">
        <div class="related-title">{{ data.related_title }}</div>
        <ul>
          <li
            v-for="(publication, index) in data.related"
            :key="'related-' + index"
          >
            <NuxtLink :to="'/publication/' + publication.post_name">{{ publication.post_title }}</NuxtLink>
          </li>
        </ul>
      </div>
    </div>
    <div ref="articles" class="articles">
      <div
        v-for="(article, index) in chapters"
        :key="index"
        class="article"
        :style="[{backgroundColor: article.background_color}, {transform: activeArticle === index ? 'translateX(' + articlePositionCurrent(index) + ')' : 'translateX(' + articlePosition(index) + ')'}, {zIndex: chapters.length - index}]"
        :class="[{highlight: highlight === index}, {dim: highlight !== index && highlight !== null}, currentClass(index)]"
        @click="setActiveArticle(index)"
      >
        <div class="article-inner">
          <div class="article-index">{{ ('0' + (index + 1)).slice(-2) }}</div>
          <!-- Modules -->
          <Component
            :is="module.acf_fc_layout.charAt(0).toUpperCase() + module.acf_fc_layout.slice(1)"
            v-for="(module, subindex) in article.modules"
            :key="subindex"
            :data="module"
            :prev="article.modules[subindex-1]"
            :next="article.modules[subindex+1]"
            :module-type="module.acf_fc_layout.toLowerCase()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax, Expo } from 'gsap'
import Wysiwyg from '@/components/modules/Wysiwyg'
import Singleimage from '@/components/modules/Singleimage'
import Video from '@/components/modules/Video'
import Motion from '@/components/modules/Motion'
import Headline from '@/components/modules/Headline'
import Galleryv2 from '@/components/modules/Galleryv2'
import Space from '@/components/modules/Space'
import Section from '@/components/modules/Section'
import Quote from '@/components/modules/Quote'
import Audio from '@/components/modules/Audio'
import List from '@/components/modules/List'
import Button from '@/components/modules/Button'
import Linklist from '@/components/modules/Linklist'
import Promov2 from '@/components/modules/Promov2'
import Layout from '@/components/modules/Layout'
export default {
  name: 'Publication',
  components: {
    Wysiwyg,
    Singleimage,
    Motion,
    Headline,
    Galleryv2,
    Space,
    Section,
    Quote,
    Audio,
    List,
    Linklist,
    Promov2,
    Layout,
    Video,
    Button
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeArticle: 0,
      highlight: null,
      animated: false,
      indexOpen: false
    }
  },
  computed: {
    chapters() {
      return this.data.chapters && this.data.chapters.length > 0
        ? this.data.chapters
        : this.data.article
    },
    testing() {
      return '60vw'
    },
    isMobile() {
      return this.$mq === 'tiny' || this.$mq === 'mobile'
    }
  },
  mounted() {
    const self = this
    if (!this.isMobile) {
      TweenMax.from(this.$refs.index, 1, {
        x: '-100%',
        delay: 0.5,
        ease: Expo.easeOut
      })
    }
    Array.from(this.$refs.articles.children).forEach((element, index) => {
      if (index !== 0) {
        TweenMax.from(element, 1 + index * 0.2, {
          x: '-150px',
          delay: 2 + index * 0.1,
          ease: Expo.easeOut
        })
        TweenMax.to(element, index * 0.2, {
          opacity: 1,
          delay: 2 + index * 0.1,
          ease: Expo.easeOut,
          onComplete: () => {
            if (index === this.$refs.articles.children.length - 1) {
              self.animated = true
              if (this.$route.query.chapter) {
                this.setActiveArticle(this.$route.query.chapter - 1)
              }
            }
          }
        })
      } else {
        TweenMax.from(element, 1.5, {
          x: '-1500px',
          delay: 1,
          ease: Expo.easeInOut
        })
        TweenMax.to(element, index * 0.2, {
          opacity: 1,
          ease: Expo.easeOut
        })
      }
    })
  },
  methods: {
    articlePosition(index) {
      const perc = index / (this.chapters.length - 1)
      const offset = 1 / (this.chapters.length - 1)
      let indexWidth = '300px'
      if (this.isMobile) {
        indexWidth = '50px'
      }
      if (index < this.activeArticle) {
        return (
          'calc((100vw - ' +
          indexWidth +
          ' - 50vw) *' +
          perc +
          ' - 100% + (100vw - ' +
          indexWidth +
          ' - 50vw) *' +
          offset +
          ')'
        )
      } else {
        return 'calc((100vw - ' + indexWidth + ' - 50vw) *' + perc + ')'
      }
    },
    articlePositionCurrent(index) {
      const perc = index / (this.chapters.length - 1)
      let indexWidth = '300px'
      if (this.isMobile) {
        indexWidth = '50px'
      }
      return 'calc((100vw - ' + indexWidth + ' - 50vw) *' + perc + ')'
    },
    setActiveArticle(index) {
      this.activeArticle = index
      this.indexOpen = false
      this.$router.push({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, {
          chapter: index + 1
        })
      })
      // const el = this.$refs.articles.children[index]
      // if (el.scrollTop < 10) {
      //   el.scrollTop = el.scrollTop + 1
      // } else {
      //   el.scrollTop = el.scrollTop - 1
      // }
    },
    highlightArticle(index) {
      this.highlight = index
    },
    clearHighlight() {
      this.highlight = null
    },
    handleScroll: function(el) {
      if (
        el.srcElement.offsetHeight + el.srcElement.scrollTop >=
        el.srcElement.scrollHeight
      ) {
        if (this.activeArticle < this.chapters.length - 1) {
          this.setActiveArticle(this.activeArticle + 1)
        }
      }
      if (el.srcElement.scrollTop <= 0) {
        if (this.activeArticle > 0) {
          this.setActiveArticle(this.activeArticle - 1)
        }
      }
    },
    currentClass(index) {
      if (index === this.activeArticle - 1) {
        return 'prev'
      } else if (index === this.activeArticle) {
        return 'current'
      } else if (index === this.activeArticle + 1) {
        return 'next'
      } else {
        return 'hide'
      }
    },
    toggleIndex() {
      this.indexOpen = true
    }
  }
}
</script>

<style lang="scss" scoped>
.publication {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw !important;
  height: 100vh !important;
  transform: none !important;
  overflow: hidden;
}
.index {
  width: 300px;
  z-index: 100;
  height: 100vh;
  padding: 60px 30px;
  position: absolute;
  box-shadow: 10px 0px 20px -10px rgba(0, 0, 0, 0.41);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: $white;
  @include media($small) {
    transform: translateX(-260px);
    transition: transform 400ms $easeOutExpo;
    &.open {
      transform: none;
      .index-button {
        opacity: 0;
        pointer-events: none;
      }
      .index-inner {
        opacity: 1;
      }
    }
  }
  .index-inner {
    width: 100%;
    @include media($small) {
      opacity: 0;
      transition: opacity 200ms;
    }
  }
  .index-button {
    width: 40px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    flex-direction: column;
    justify-content: center;
    transition: opacity 200ms;
    display: none;
    @include media($small) {
      display: flex;
    }
    a {
      white-space: nowrap;
      display: block;
      transform: rotate(-90deg);
      @include font('label');
      text-transform: uppercase;
    }
  }
  .related {
    margin-top: 30px;
    .related-title {
      text-align: center;
      @include font('label');
      text-transform: uppercase;
      opacity: 0.5;
    }
    a {
      opacity: 0.5;
      transition: all 100ms;
      &:hover {
        opacity: 1;
      }
    }
  }
  li {
    cursor: pointer;
    text-align: center;
    transition: opacity 100ms;
    &.dim {
      opacity: 0.3;
    }
  }
}
.articles {
  position: absolute;
  left: 300px;
  top: 0;
  width: calc(100vw - 300px);
  height: 100vh;
  @include media($small) {
    left: 40px;
    width: calc(100vw - 40px);
  }
}
.menu-wrapper {
  position: relative;
  .menu-preloader {
    position: absolute;
    width: 100%;
    top: 40px;
    text-align: center;
    transition: opacity 100ms;
    img {
      margin: 0 auto;
    }

    .animation-done & {
      opacity: 0;
      pointer-events: none;
    }
  }
  ul {
    opacity: 0;
    pointer-events: none;
    transition: opacity 100ms ease-out 200ms;

    .animation-done & {
      opacity: 1;
      pointer-events: auto;
    }
  }
}
.article {
  background-color: $main-color;
  width: 50vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  box-shadow: 10px 0px 20px -10px rgba(0, 0, 0, 0.41);
  opacity: 0;
  .animation-done & {
    transition: all 800ms $easeOutExpo;
  }
  cursor: pointer;
  @include media($small) {
    width: calc(100vw - 140px);
  }
  @include media($mobile) {
    width: calc(100vw - 90px);
  }
  &.highlight {
    left: 15px;
    @include media($mobile) {
      left: 0;
    }
  }
  ::v-deep .module {
    background-color: transparent !important;
  }
  &:not(.current) {
    &:hover {
      left: 15px;
      @include media($mobile) {
        left: 0;
      }
    }
  }
  .article-index {
    text-align: right;
    padding: 20px 0;
  }
  &.current {
    overflow: scroll;
    cursor: auto;
    @include media($small) {
      width: auto;
      transform: translateX(50px) !important;
    }
    @include media($mobile) {
      transform: translateX(0) !important;
    }
    .article-inner {
      pointer-events: auto;
    }
  }
  &.prev {
    @include media($small) {
      transform: translateX(calc(50px - 100%)) !important;
    }
    @include media($mobile) {
      transform: translateX(-100%) !important;
    }
  }
  &.next {
    @include media($small) {
      transform: translateX(calc(100vw - 100% - 40px)) !important;
    }
  }
  &.hide {
    @include media($small) {
      display: none;
    }
  }
  .article-inner {
    width: 50vw;
    float: right;
    transition: opacity 200ms;
    padding: 0 20px;
    min-height: 101vh;
    position: relative;
    pointer-events: none;
    @include media($small) {
      width: calc(100vw - 140px);
      float: none;
    }
    @include media($mobile) {
      width: calc(100vw - 90px);
    }
  }
}
.index-title {
  font-weight: 500;
  @include fontsize(20);
}
.index-description {
  font-style: italic;
  font-family: adobe-garamond-pro;
  @include fontsize(15);
}
.title {
  @include fontsize(30);
  text-align: center;
  font-family: adobe-garamond-pro;
}
.description {
  @include fontsize(20);
  text-align: center;
  font-family: adobe-garamond-pro;
  font-style: italic;
  margin-bottom: 30px;
}
.logo {
  text-align: center;
  margin-bottom: 20px;
  svg,
  img {
    max-width: 80px;
    height: auto;
  }
}
</style>
